import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

const RouterSync = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const query = {};

        for (const [key, value] of queryParams.entries()) {
            if (query[key]) {
                // Handle multiple values for the same key (like statuses=paused&statuses=active)
                if (Array.isArray(query[key])) {
                    query[key].push(value);
                } else {
                    query[key] = [query[key], value];
                }
            } else {
                query[key] = value;
            }
        }

        dispatch({
            type: '@@router/LOCATION_CHANGE',
            payload: {
                pathname: location.pathname,
                search: location.search,
                hash: location.hash,
                state: location.state,
                action: 'POP',
                query: query
            }
        });
    }, [location, dispatch]);

    return children;
};

export default RouterSync;
